/**
 * @generated SignedSource<<91da60073b7c1776003aa2edbac72a07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SubscribeToOfferResultKind = "BLOCKED" | "OK";
export type subscribeButton_SubscribeToOfferMutation$variables = {
  offerId: string;
};
export type subscribeButton_SubscribeToOfferMutation$data = {
  readonly Admin: {
    readonly Offer: {
      readonly subscribeToOffer: {
        readonly kind: SubscribeToOfferResultKind;
        readonly missingElementTypes?: ReadonlyArray<string>;
      };
    };
  };
};
export type subscribeButton_SubscribeToOfferMutation = {
  response: subscribeButton_SubscribeToOfferMutation$data;
  variables: subscribeButton_SubscribeToOfferMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "offerId",
    "variableName": "offerId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "missingElementTypes",
      "storageKey": null
    }
  ],
  "type": "SubscribeBlocked",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "subscribeButton_SubscribeToOfferMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Offer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "subscribeToOffer",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "subscribeButton_SubscribeToOfferMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Offer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "subscribeToOffer",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "126dd356a4734f82230bd3e3ab2d1dd8",
    "id": null,
    "metadata": {},
    "name": "subscribeButton_SubscribeToOfferMutation",
    "operationKind": "mutation",
    "text": "mutation subscribeButton_SubscribeToOfferMutation(\n  $offerId: ID!\n) {\n  Admin {\n    Offer {\n      subscribeToOffer(offerId: $offerId) {\n        __typename\n        kind\n        ... on SubscribeBlocked {\n          missingElementTypes\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9e49684de9adc8d36ab5ba635152289";

export default node;
